
import cloneDeep from 'lodash/cloneDeep'

export const FORM_ELEMENT_TYPE = {
    section: 'section',
    checkbox: 'checkbox',
    radio: 'radio'
}
const initPermissions = {
    sm: {
        full: false, partial: false
    },
    analytics: {
        sm_full: false, sm_partial: false
    },
    useractions: {
        assign: false,
        status: false,
        tags_modify: false,
        tags_delete: false,
        shared_views_modify: false,
        shared_views_delete: false,
        user_availability_modify: false,
        chat_user_availability_modify: false,
    },
    connectors: false,
    emailTemplates: {
        create: false,
        share: false,
        view_all: false,
        modify: false,
        delete: false
    },
    sla:{
        manage: false,
        remove: false
    },
    customer_module:{
        can_change_contact_on_conversation: true,
        can_access_contact_directory: false
    },
    kb:{
        can_create_categories_and_articles: false,
        can_configure_settings_and_users: false
    }
}
export const initCurrentRoleState = {
    fields: {
        name: {
            value: '', error: 'This is required'
        },
        description: {
            value: '', error: 'This is required'
        }
    },
    permissions: initPermissions,
    forComparison: null
}
//private to this module, hence a very generic name
function getValue(state) {
    return getStateValue(state, ...this.code.split('.'))
}

export const permissionElements = [{
    type: FORM_ELEMENT_TYPE.section,
    title: 'Admin Panel',
    children: [{
        type: FORM_ELEMENT_TYPE.section,
        title: 'Shared Inboxes/ Shared Labels',
        children: [{
            type: FORM_ELEMENT_TYPE.radio,
            title: 'Can access settings for all shared inboxes/ labels',
            code: 'sm.full',
            getValue
        }, {
            type: FORM_ELEMENT_TYPE.radio,
            title: 'Can only access settings for shared inboxes/ labels that they are a part of',
            code: 'sm.partial',
            getValue
        }, {
            type: FORM_ELEMENT_TYPE.radio,
            code: 'sm.none',
            title: 'Cannot access shared inboxes/ labels settings',
            getValue: function(state) {
                const full = getStateValue(state, 'sm', 'full')
                const partial = getStateValue(state, 'sm' , 'partial')
                return !(full || partial)
            }
        }]
    }, {
        type: FORM_ELEMENT_TYPE.checkbox,
        title: 'Connectors',
        code: 'connectors',
        getValue
    }]
}, {
    type: FORM_ELEMENT_TYPE.section,
    title: 'Analytics', 
    children: [{
        type: FORM_ELEMENT_TYPE.radio,
        title: 'Can access analytics for all shared inboxes',
        code: 'analytics.sm_full',
        getValue
    }, {
        type: FORM_ELEMENT_TYPE.radio,
        title: 'Can access analytics for shared inboxes they are a part of',
        code: 'analytics.sm_partial',
        getValue
    }, {
        type: FORM_ELEMENT_TYPE.radio,
        title: 'Cannot access analytics',
        code: 'analytics.sm_none',
        getValue: (state) => {
            const sm_full =  getStateValue(state, 'analytics', 'sm_full')
            const sm_partial = getStateValue(state, 'analytics', 'sm_partial')
            return !(sm_full || sm_partial)
        }
    }]
}, {
    type: FORM_ELEMENT_TYPE.section,
    title: 'User Actions', 
    children: [{
        type: FORM_ELEMENT_TYPE.checkbox,
        title: 'Can assign conversations',
        code: 'useractions.assign',
        getValue
    }, {
        type: FORM_ELEMENT_TYPE.checkbox,
        title: 'Can change status of conversations',
        code: 'useractions.status',
        getValue
    }, {
        type: FORM_ELEMENT_TYPE.checkbox,
        title: 'Can create and rename tags',
        code: 'useractions.tags_modify',
        getValue
    },{
        type: FORM_ELEMENT_TYPE.checkbox,
        title: 'Can delete tags',
        code: 'useractions.tags_delete',
        getValue
    },{
        type: FORM_ELEMENT_TYPE.checkbox,
        title: 'Can create and modify shared views',
        code: 'useractions.shared_views_modify',
        getValue
    },{
        type: FORM_ELEMENT_TYPE.checkbox,
        title: 'Can delete shared views',
        code: 'useractions.shared_views_delete',
        getValue
    },
    {
        type: FORM_ELEMENT_TYPE.checkbox,
        title: 'Can manage user availability for email auto assignment',
        code: 'useractions.user_availability_modify',
        getValue
    },
    {
        type: FORM_ELEMENT_TYPE.checkbox,
        title: 'Can manage user availability for chat',
        code: 'useractions.chat_user_availability_modify',
        getValue
    }
]
}, {
    type: FORM_ELEMENT_TYPE.section,
    title: 'Email Templates',
    children: [{
        type: FORM_ELEMENT_TYPE.checkbox,
        title: 'Can create templates',
        code: 'emailTemplates.create',
        getValue
    },{
        type: FORM_ELEMENT_TYPE.checkbox,
        title: 'Can share templates with others',
        code: 'emailTemplates.share',
        getValue
    }, {
        type: FORM_ELEMENT_TYPE.section,
        title: 'Can view',
        code: 'emailTemplates.view_all',
        children: [{
            type: FORM_ELEMENT_TYPE.radio,
            title: 'templates created by anyone',
            code: 'emailTemplates.view_all',
            getValue
        }, {
            type: FORM_ELEMENT_TYPE.radio,
            title: 'templates shared with them',
            code: 'emailTemplates.view_all-none',
            getValue: (state) => {
                return !getStateValue(state, 'emailTemplates', 'view_all')
            }
        }]
    }, {
        type: FORM_ELEMENT_TYPE.section,
        title: 'Can rename, modify content and change folder of',
        code: 'emailTemplates.modify',
        children: [{
            type: FORM_ELEMENT_TYPE.radio,
            title: 'templates created by anyone',
            code: 'emailTemplates.modify',
            getValue
        }, {
            type: FORM_ELEMENT_TYPE.radio,
            code: 'emailTemplates.modify-none',
            title: 'templates created by themselves',
            getValue: (state) => {
                return !getStateValue(state, 'emailTemplates', 'modify')
            }
        }]
    }, {
        type: FORM_ELEMENT_TYPE.section,
        title: 'Can delete',
        code: 'emailTemplates.delete',
        children: [{
            type: FORM_ELEMENT_TYPE.radio,
            title: 'templates created by anyone',
            code: 'emailTemplates.delete',
            getValue
        }, {
            type: FORM_ELEMENT_TYPE.radio,
            title: 'templates created by themselves',
            code: 'emailTemplates.delete-none',
            getValue: (state) => {
                return !getStateValue(state, 'emailTemplates', 'delete')
            }
        }]
    }]
},
{
    type: FORM_ELEMENT_TYPE.section,
    title: 'SLA', 
    children: [
        {
            type: FORM_ELEMENT_TYPE.checkbox,
            title: 'Can manage (create/edit/prioritise/disable) SLAs',
            code: 'sla.manage',
            getValue
        },
        {
            type: FORM_ELEMENT_TYPE.checkbox,
            title: 'Can remove SLA manually from conversations',
            code: 'sla.remove',
            getValue
        }
    ]
},

{
    type: FORM_ELEMENT_TYPE.section,
    title: 'Contacts', 
    children: [
        {
            id: 'customer_change_contact',
            type: FORM_ELEMENT_TYPE.checkbox,
            title: 'Can change contact on a conversation',
            code: 'customer_module.can_change_contact_on_conversation',
            getValue
        },
        {
            id: 'customer_contact_directory',
            type: FORM_ELEMENT_TYPE.checkbox,
            title: 'Can access contact directory',
            code: 'customer_module.can_access_contact_directory',
            getValue
        }
    ]
},

{
    type: FORM_ELEMENT_TYPE.section,
    title: 'Knowledge Base', 
    description: {
        text: (roleName) => `For ${roleName}s who are added to the knowledge base`,
        availableTo: ["Mailbox Admin", "Supervisor", "Member"],
    },
    children: [
        {
            type: FORM_ELEMENT_TYPE.checkbox,
            title: 'Can create categories and publish articles',
            code: 'kb.can_create_categories_and_articles',
            availableTo: ["Admin", "Mailbox Admin", "Supervisor", "Member"],
            getValue
        },
        {
            type: FORM_ELEMENT_TYPE.checkbox,
            title: 'Can configure settings and manage users',
            code: 'kb.can_configure_settings_and_users',
            availableTo: ["Admin"],
            getValue
        },
    ]
},


]

export function getStateValue (src, ...keys) {
    if (keys.length == 1)  {
        return src ? src[keys[0]] : false
    } else
        return getStateValue(src[keys[0]], ...keys.slice(1))
}

export function setStateValue(state, value, ...keys) {
    if (typeof state === "object") {
        if (keys.length == 1 && state.hasOwnProperty(keys[0])) {
            state[keys[0]] = value
            return true
        } else 
            return setStateValue(state[keys[0]], value, ...keys.slice(1))
    } 
    return false        
}

export function getStateFromPermissions(permissions) {
    const state =  cloneDeep(initCurrentRoleState.permissions)
    permissions.forEach(permission => {
        const { code, enabled } = permission
        const codeArr = code.split('.')
        const stateItem = getStateValue(state, ...codeArr)
        if (typeof stateItem === 'boolean' && stateItem !== enabled) {
            setStateValue(state, enabled, ...codeArr)
        }
    })
    return state
}
export function filterUnnecessaryPermissionCodes (permissions) {
    const filterOut = [
        'sm.none', 'emailTemplates.delete-none', 'emailTemplates.view_all-none',
        'emailTemplates.modify-none', 'analytics.sm_none'
    ]
    return permissions.filter(permission => !filterOut.includes(permission))
}
export function getPermissionsFromState(permissionState, featureKeys, prevKey = ''){
    let permissionArr = []

    for(let key in permissionState) {
        const value = permissionState[key]
        const nextKey = `${prevKey}${prevKey ? '.': ''}${key}`;

        const isKeyInFeatureKey = featureKeys[prevKey];

        if(isKeyInFeatureKey && !featureKeys[prevKey][key]){
            continue;
        }

        if (value === true) 
            permissionArr.push(nextKey)
        else if(typeof value === 'object')
            permissionArr = [...permissionArr, ...getPermissionsFromState(value, featureKeys, nextKey)]
    }
    return permissionArr
}

export const getChangesForRoles = (users, roleId, targets) => {
    return users.filter(user => targets.includes(user.id))
                .map(user => ({
                    userId: user.id,
                    roleId,
                    oldRoleId: user.roleid
                }))
}

export function getUserNextTier(currUser, newUsers) {
    const totalUsers = currUser + newUsers
    if (totalUsers <= 2) {
        return "1-2";
    } else if (totalUsers <= 5) {
        return "3-5";
    } else {
        const lower = Math.floor((totalUsers - 1) / 5) * 5 + 1;
        const upper = lower + 4;
        return `${lower}-${upper}`;
    }
}

// Calculates the number of additional seats the user will be billed for, based on tiered user slabs.
// Tier logic:
// - If currentUsers is in the 1–2 range, the first jump gives 3 additional seats.
// - After the initial 3 seats, every additional tier of 5 users adds 5 more seats.
// - For users beyond tier 2, additional seats are calculated in multiples of 5.
export function getAdditionalSeatsCount(currentUsers, newUsers) {
    let additionalSeats = 0;
    if (currentUsers <= 2) {
      additionalSeats += 3;
      const remainingUsers = newUsers -  3;
      if (remainingUsers > 0) {
        additionalSeats += 5 * Math.ceil(remainingUsers / 5);
      }
    } else {
        additionalSeats += 5 * Math.ceil(newUsers / 5);
    }
    return additionalSeats;
}
